import parseTitle from './parse-title'

import config from '../../config'

export const buildMeta = (rawData, pathname = window?.location?.pathname, getRoutePath) => {
	const data = {...rawData};
	data.canonical = config.siteURL + (data.canonical ? data.canonical : pathname);
	data.url = config.siteURL + pathname;

	let parsedMeta = [];
	for(const metaKey in data) {
		const metaVal = data[metaKey];
		switch(metaKey) {
			case 'title':
				parsedMeta.push({
					key: 'title',
					content: parseTitle(metaVal),
				})
				parsedMeta.push({
					key: 'meta',
					props: {
						property: 'og:title',
						content: parseTitle(metaVal),
					}
				})
			break;
			case 'type':
				parsedMeta.push({
					key: 'meta',
					props: {
						property: 'og:type',
						content: metaVal,
					}
				})
			break;
			case 'image':
				parsedMeta.push({
					key: 'meta',
					props: {
						property: 'og:image',
						content: metaVal,
					}
				})
			break;
			case 'description':
				if(metaVal) {
					var description = metaVal.replace(/<br\s*[/]?>/gi, '\n').replace(/<[^>]*>?/gm, '');
					parsedMeta.push({
						key: 'meta',
						props: {
							name: 'description',
							property: 'description',
							content: description,
						}
					})
					parsedMeta.push({
						key: 'meta',
						props: {
							property: 'og:description',
							content: description,
						}
					})
				}
			break;
			case 'schema':
				const metaVals = metaVal ? (Array.isArray(metaVal) ? metaVal : [metaVal]) : false;
				
				if(metaVals) {
					for(const val of metaVals) {
						parsedMeta.push({
							key: 'script',
							content: val,
							props: {
								type: 'application/ld+json',
							}
						})
					}
				}
			break;
			case 'canonical': 
				parsedMeta.push({
					key: 'link',
					props: {
						rel: 'canonical',
						href: metaVal,
					}
				})
			break;
			case 'url': 
				parsedMeta.push({
					key: 'meta',
					props: {
						property: 'og:url',
						content: metaVal,
					}
				})
			break;
			case 'status': 
				parsedMeta.push({
					key: "meta",
					props: {
						name: "prerender-status-code",
						content: metaVal,
					}
				})
			break;
			case 'subtitle':
			break;
			// Fallback for internal mechanism.
			case 'loaded':
			break;
			case 'breadcrumbs':
				

				parsedMeta.push({
					key: 'script',
					content: JSON.stringify({
						"@context": "https://schema.org",
						"@type": "BreadcrumbList",
						"itemListElement": (() => {
							let crumbs = [
								{
									"@type": "ListItem",
									"position": 1,
									"name": "Anasayfa",
									"item": config.siteURL,
								}
							];
					
							if(metaVal) {
								for(let k = 0; k < metaVal.length; k++) {
									crumbs.push({
										"@type": "ListItem",
										"position": k+2,
										"name": metaVal[k].name,
										"item": config.siteURL + ((metaVal[k].href && getRoutePath) ? getRoutePath(metaVal[k].href, metaVal[k].params) : pathname),
									})
								}
							}
							else {	
								if(window.location.pathname !== '/') {
									crumbs.push({
										"@type": "ListItem",
										"position": 2,
										"name": data['title'],
										"item": config.siteURL + pathname,
									});
								}
							}
							
							return crumbs;
						})()
					}),
					props: {
						type: 'application/ld+json',
					}
				})
			break;
			default: 
				if(typeof metaVal === 'object'){
					parsedMeta.push(metaVal)
				}
				else {
					console.warn(`Invalid meta: ${metaKey}`);
				}
			break;
		}
	}

	return parsedMeta;
}

export default buildMeta;